module.exports = __webpack_public_path__ + "static/media/brand-logo.e8dc37e1.svg";